import { render, staticRenderFns } from "./eComplaintGeneralData.vue?vue&type=template&id=ab07639e"
import script from "./eComplaintGeneralData.vue?vue&type=script&lang=js"
export * from "./eComplaintGeneralData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports